// Pages without product cards only need the swatch code if cards arrive later.
// This covers the cart drawer, recommendations and dynamically inserted sections.
(function () {
  const src = document.currentScript?.dataset.swatchesSrc;
  if (!src || window.kibraVariantImageSwatchesReady) return;
  const selector = '[data-product-handle]';
  let loading = false;
  let observer;

  function load() {
    if (loading || window.kibraVariantImageSwatchesReady) return;
    loading = true;
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = () => observer?.disconnect();
    script.onerror = () => {
      loading = false;
      script.remove();
    };
    document.head.appendChild(script);
  }

  observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 &&
            (node.matches(selector) || node.querySelector(selector))) {
          load();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (document.querySelector(selector)) load();
})();
